// Third party
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Actions
import { getMe } from '../../../../redux/modules/auth';

// Components
import TwoFactorAuthFlow from './TwoFactorAuthFlow';
import User from '@/types/user';
import Modal from '@/views/components/modals/AccessibleModal';

type DispatchProps = {
  getMe: (contextId?: string) => Promise<User>;
};

type Props = DispatchProps & {
  show?: boolean;
  onDone: () => void;
  onCancel?: () => void;
};

export class Enable2FAModal extends Component<Props> {
  render() {
    const { show, onDone, onCancel } = this.props;

    return (
      <Modal centered show={show} backdrop="static" className="two-factor-container modal">
        <Modal.Body>
          <TwoFactorAuthFlow onCancel={onCancel} onDone={onDone} onConfirmationCodeSubmitted={this.props.getMe} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default connect(null, { getMe })(Enable2FAModal);
